export default __webpack_public_path__ + "static/media/product4.042f70e7.webp";